// How far down the page the user has to scroll before his actions can be
// considered tacit acceptance
const SCROLL_THRESHOLD_PERCENTAGE = 50 / 100


/**
 * Queries window.document to determine how far the user has scrolled.
 *
 * @returns {Boolean} true when the user has scrolled beyond the tacit-approval threshold
 */
export default function isScrolledToAccept() {
  // We don't use `e.body` and `e.documentElement` here because, in at least one
  // circumstance, `documentElement` was undefined. Our hope here is that
  // `window.document` will be more reliable.
  const {
    body,
    documentElement,
  } = window.document

  const minScrollPx = SCROLL_THRESHOLD_PERCENTAGE * (documentElement.scrollHeight - window.innerHeight)

  return ( body.scrollTop >= minScrollPx || documentElement.scrollTop >= minScrollPx )
}
